import React from 'react'
import styled from 'styled-components'

type DefaultButtonIconProps = {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
}

export const IconWrapper = styled.div`
  height: 20px;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
`

export const DefaultButtonIcon: React.FC<DefaultButtonIconProps> = (
  props: DefaultButtonIconProps,
) => {
  const Icon = props.icon
  return (
    <IconWrapper>
      <Icon />
    </IconWrapper>
  )
}
